import { render, staticRenderFns } from "./AddMonthlyPay.vue?vue&type=template&id=fa2e5d4c&scoped=true"
import script from "./AddMonthlyPay.vue?vue&type=script&lang=js"
export * from "./AddMonthlyPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2e5d4c",
  null
  
)

export default component.exports